var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emptyList"},[_vm._v(_vm._s(_vm.$t("Home.dashboard.summary.emptyList")))])
}
var staticRenderFns = []

export { render, staticRenderFns }